import { NetworkBasePopUp } from '../NetworkBasePopUp';
import { translateFn } from '../../../../utils/translator.helper';
import {UnsetVmwareIntegratorWebComponent} from "./component/UnsetVmwareIntegratorWebComponent";
import {FooterButton} from "../NetworkPopUpFooterContentWebComponent";
import {ButtonColors, ButtonTypes} from "../../../../ui/gzButton/types";
import {ConsoleRequest, DataProviderEntity, DataProviderType} from "../../../../utils/request";
import {GzDialog} from "../../../../ui/gzDialog/component/GzDialog";
import { UnsetVMwareRecordsResponse } from './types';
import { AFTER_ASSIGN_VMWARE_EVENT_NAME } from '../setVmwareIntegrator/SetVmwareIntegratorPopUp';

export const AFTER_UNASSIGN_VMWARE_EVENT_NAME = 'afterUnassignVmwareIntegrator';


export class UnsetVmwareIntegratorPopUp extends NetworkBasePopUp<UnsetVmwareIntegratorWebComponent> {
  protected transformToTaskTarget = true;
  protected customEventNameAfterConfirm = AFTER_UNASSIGN_VMWARE_EVENT_NAME;
  protected title = translateFn('Unassign vCenter integrator');
  private isError = false;
  protected extraDialogConfigs: Partial<GzDialog>;

  protected successDialogMessage = translateFn('Successfully unassigned the integrator.');
  protected errorDialogMessage = translateFn('Failed to unassign the integrator.');

  private dialogButtonsConfig: Partial<FooterButton>[] = [
    {
      id: 'confirmButton',
      label: translateFn('Unassign'),
      type: ButtonTypes.FULL,
      color: ButtonColors.PRIMARY,
    },
    {
      id: 'cancelButton',
      label: translateFn('Cancel'),
    },

  ];

  protected customSetup() {
    if (!this.data.targets) {
      throw new Error('Missing targets');
    }

    this.popUpContent = new UnsetVmwareIntegratorWebComponent();
    this.popUpFooterButtons = this.dialogButtonsConfig;
  }

  protected async handleConfirmButtonClicked(event: CustomEvent) {
    if (this.isError) {
      return;
    }

    if (!this.data.targets) {
      throw new Error('Missing targets');
    }

    try {
      const response: UnsetVMwareRecordsResponse = await ConsoleRequest.createRequest<UnsetVMwareRecordsResponse>({
        dataProviderType: DataProviderType.ENDPOINTS,
        dataProviderEntity: DataProviderEntity.MODEL,
        endpoint: 'UnifiedEndpoints',
        method: 'unsetVCenterIntegrator',
        payload: {
          protectedEntityId: this.data.targets[0]._id,
        },
      });

      if (response?.success) {
        this.showCustomToast(this.successDialogMessage);
      } else {
        this.showErrorToastNotification(this.errorDialogMessage);
      }

    } catch (e) {
      this.showErrorToastNotification(this.errorDialogMessage);
    }

  }
}
